import ApiService from './apiService';
import apiCache from './apiCache';
import { apiInterceptor } from '../../utils/errorUtils';
export default (function (baseUrl, headers) {
  var instance = ApiService(baseUrl, headers, {
    adapter: apiCache.adapter
  });
  apiInterceptor(instance);
  return instance;
});